import script from "./check-payroll-report.vue?vue&type=script&setup=true&lang=js"
export * from "./check-payroll-report.vue?vue&type=script&setup=true&lang=js"

import "./check-payroll-report.vue?vue&type=style&index=0&id=8d03818c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d03818c"]])

export default __exports__